<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('menu.company_conversions')"/>
        <div class="col-12 nopads mt-2">
            <!-- Tabs -->
            <ul class="nav nav-tabs routa-tabs">
                <li class="nav-item routa-tab-nav-item">
                    <button class="routa-tab" :class="{ active: activeTab === 1 }" @click="activeTab = 1">
                        {{ $t('menu.conversion_models') }}
                    </button>
                     </li>
                <li class="nav-item">
                    <button class="routa-tab" :class="{ active: activeTab === 2 }" @click="activeTab = 2">
                        {{  $t('menu.task_types_conversion_table')  }}
                    </button>
                     </li>
                <li class="nav-item">
                    <button class="routa-tab" :class="{ active: activeTab === 3 }" @click="activeTab = 3">
                        {{  $t('menu.accounts_conversion_table')  }}
                    </button>
                </li>
            </ul>
            <!-- Content -->
            <div class="tab-content routa-tab-content">
                <div class="tab-pane fade" :class="{ show: activeTab === 1, active: activeTab === 1 }">
                    <conversion-models/>
                </div>
                <div class="tab-pane fade" :class="{ show: activeTab === 2, active: activeTab === 2 }">
                    <conversion-task-type-models/>
                </div>
                <div class="tab-pane fade" :class="{ show: activeTab === 3, active: activeTab === 3 }">
                    <conversion-account-models/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Navbar from "@/components/utils/Navbar";
import ConversionTaskTypeModels from "@/components/tasktype/conversion/ConversionTaskTypeModels";
import ConversionModels from "@/components/pricingmodels/conversion/ConversionModels";
import ConversionAccountModels from "@/components/account/conversion/ConversionAccountModels.vue";

export default {
    name: 'Conversions',
    components: {
        ConversionAccountModels,
        ConversionModels,
        ConversionTaskTypeModels,
        Navbar
    },
    data: function () {
        return {
            activeTab: 1,
        }
    }
}
</script>
